/*
This middleware is used to redirect the user to the login page if they are not authenticated.
*/

import { useUserStore } from "~/store/user.store";
export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();

  // The scope of this middleware is to only redirect users if they are within the /app/* routes
  if (!to.path.startsWith("/app")) {
    return;
  }

  // If the user is authenticated, continue to the requested route
  if (userStore.isAuthenticated) {
    return;
  }

  const authCookie = useCookie<{ access: string; refresh: string }>("jwtToken");

  if (!authCookie.value) {
    return navigateTo("/auth/login");
  }

  // At this point, the user is not authenticated and is trying to access a route within the /app/* routes
  // Now we want to automatically log in the user if they have a valid token so they do not have to manually log in
  const success = await userStore.performLocalLogin(authCookie.value);

  if (!success) {
    return navigateTo("/auth/login");
  }

  if (userStore.jwtToken) authCookie.value = userStore.jwtToken; // Update cookie

  try {
    localStorage.setItem(
      "preferredLanguage",
      userStore.user?.language_preference || "en"
    );
  } catch (error) {
    console.error("Failed to set preferred language:", error);
  }
});
